import React from 'react'
import { StyleSheet, css } from 'aphrodite'

const styles = StyleSheet.create({
  label: {
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 5,
    userSelect: 'none',
    ':hover': {
      background: '#ececec',
      cursor: 'pointer'
    }
  }
})

export default ({ onSelect, label }) => {
  return (
    <li style={{ background: '#fff' }} onClick={onSelect}>
      <div className={css(styles.label)}>{label}</div>
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/components/Menu/ContextMenu/menuItem.js